<template>
  <div>
  <!-- 采购类型选择弹窗（在发起采购前选择） -->
  <v-dialog
    v-model="typeSelectVisible"
    max-width="400"
    persistent
  >
    <v-card class="purchase-dialog purchase-type-card">
      <v-card-title class="d-flex justify-space-between align-center">
        <span>采购类型</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="closeTypeSelect"
        />
      </v-card-title>
      <v-card-text class="d-flex gap-3 justify-space-between">
        <v-btn
          color="primary"
          variant="flat"
          size="large"
          width="45%"
          @click="selectPurchaseType(0)"
        >
          实物采购
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          size="large"
          width="45%"
          @click="selectPurchaseType(1)"
        >
          服务采购
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- 发起采购对话框 -->
  <v-dialog
    v-model="visible"
    max-width="1250"
    height="80vh"
    persistent
  >
    <v-card class="purchase-dialog">
      <v-card-title class="d-flex justify-space-between align-center">
        <div class="d-flex justify-space-between align-center" style="flex: 1;">
          <div>
            {{
              purchaseData.purchaseOrderNo
                ? purchaseData.purchaseType === 0
                  ? '修改实物采购'
                  : '修改服务采购'
                : purchaseData.purchaseType === 0
                  ? '发起实物采购'
                  : '发起服务采购'
            }}
          </div>
          <div style="margin-top: 4px;text-align: right;">
            <div v-if="props.projectName" style=" font-size: 18px;">{{ props.projectName }}</div>
            <div v-if="props.contractCode" style=" font-size: 14px;color: #A5A5A5;line-height: 1;">{{ props.contractCode }}</div>
          </div>
        </div>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="handleClose"
        />
      </v-card-title>
      <v-card-text>
        <v-form ref="purchaseForm" v-model="purchaseValid">
          <!-- 供应商选择 -->
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                v-model="purchaseData.vendor"
                :search="vendorSearchText"
                @update:search="val => (vendorSearchText = val)"
                :items="vendorSearchText ? vendorList : []"
                :loading="vendorLoading"
                :no-filter="true"
                item-title="companyName"
                item-value="id"
                label="供应商"
                placeholder="请输入供应商名搜索"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                :no-data-text="vendorSearchText ? '没有找到匹配的供应商' : '请输入供应商名进行搜索'"
                clearable
                return-object
              >
                <template v-slot:item="{ props, item }">
                  <v-list-item
                    v-bind="props"
                    :title="item.raw.companyName"
                    :subtitle="item.raw.type ? `${item.raw.type}` : ''"
                  />
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="purchaseData.warehouse"
                :items="warehouseSelectItems"
                item-title="warehouseName"
                item-value="warehouseNo"
                label="收货仓库"
                placeholder="请选择收货仓库"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                return-object
              />
            </v-col>
            <v-col cols="5" v-if="purchaseData.purchaseType === 0">
              <v-select
                v-model="purchaseData.purchaseStandard"
                :items="purchaseStandardList"
                item-title="value"
                item-value="value"
                label="采购标准"
                placeholder="请选择采购标准"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                return-object
              />
            </v-col>
            <v-col cols="5" v-if="purchaseData.purchaseType === 1">
              <v-text-field
                label="送货地址"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model="purchaseData.deliveryAddress"
                placeholder="请输入送货地址"
              />
            </v-col>
          </v-row>
          <!-- 付款信息 -->
          <v-row class="mt-4">
            <v-col>
              <v-select
                v-model="purchaseData.paymentMethod"
                :items="paymentMethods"
                label="付款方式"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                item-title="label"
                item-value="value"
              />
            </v-col>
            <v-col>
              <v-select
                v-model="purchaseData.taxRate"
                :items="taxRates"
                label="税率"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                item-title="label"
                item-value="value"
                return-object
              />
            </v-col>
            <v-col>
              <v-select
                v-model="purchaseData.tax"
                :items="taxs"
                label="是否含税"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                item-title="label"
                item-value="value"
                return-object
              />
            </v-col>
            <v-col>
              <v-select
                v-model="purchaseData.paymentCompany"
                :items="paymentCompanys"
                label="付款公司"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                item-title="label"
                item-value="value"
                return-object
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="purchaseData.taxAmount"
                label="税额"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                type="number"
                @wheel="preventNumberInputWheel"
                class="v-field--readonly"
                readonly
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="合计金额"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                :model-value="purchaseData.totalAmount"
                type="number"
                @wheel="preventNumberInputWheel"
                class="v-field--readonly"
                readonly
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="含税总金额"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details="auto"
                v-model.number="purchaseData.totalAmountWithTax"
                type="number"
                @wheel="preventNumberInputWheel"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="purchaseData.remark"
                label="采购备注"
                persistent-placeholder
                variant="outlined"
                density="compact"
                hide-details
                rows="2"
                resize="false"
                auto-grow
                maxlength="500"
              ></v-textarea>
            </v-col>
          </v-row>
          <!-- 明细列表 -->
          <div class="d-flex justify-space-between align-center" style="margin-top: 24px;">
            <div style="color: #fff; font-size: 16px; font-weight: bold;">明细</div>
          </div>
          <div class="material-purchase-list">
            <div class="material-purchase-header">
              <div style="color:#fff;margin-right: 10px;"></div>
              <div class="item-content" style="width: 14%; text-align: left;">采购项</div>
              <div class="item-content" style="width: 11%; text-align: left;">下单状态</div>
              <div class="item-content" style="width: 7%; text-align: left;">关联产品</div>
              <div class="item-content text-left" style="width: 16%;">
                总数量
                <div style="color: #898989;font-size:12px;">{{ totalMaterialCount }}</div>
              </div>
              <div class="item-content" style="width: 100px;"></div>
              <div class="item-content" style="width: 100px;"></div>
              <div class="item-content" style="width: 13%;"></div>
              <div class="item-content" style="flex: 1;"></div>
              <div class="item-content" style="width: 180px;"></div>
              <div class="item-content" style="width: 40px;"></div>
            </div>
            <div class="material-purchase-body">
              <div
                v-for="(material,index) in selectedMaterialDetails"
                :key="material.id"
                class="material-purchase-item"
              >
                <div style="color:#fff;margin-right: 10px;">{{ index + 1 }}</div>
                <!-- height: -webkit-fill-available; -->
                <div class="item-content" style="width: 14%;">
                  <template v-if="material.type === 1 && (material._isExtraExpense || isExpenseType(material.materialName))">
                    <v-select
                      v-model="material.materialName"
                      :items="expenseTypePurchaseOptions"
                      label="费用类型"
                      persistent-placeholder
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      :readonly="isMaterialReadonly(material)"
                      :class="isMaterialReadonly(material) ? 'v-field--readonly' : ''"
                    />
                  </template>
                  <div v-else-if="material.type === 0" :class="!isMaterialReadonly(material) ? 'edit-parent' : ''" @click="!isMaterialReadonly(material) && openMaterialFieldDialog(material)">
                    <img v-if="!isMaterialReadonly(material)" :src="editIcon" alt="编辑" style="position: absolute;right: -6px;top: -6px;width: 16px;height: 16px;">
                    <div class="material-name" style="text-align: left;">{{ material.partName }}</div>
                    <div class="material-name" style="text-align: left;">{{ material.materialName }}</div>
                    <div style="text-align: left;">{{ material.specDesc }}</div>
                    <!-- <div class="material-code" style="text-align: left;">{{ material.contractCode }}</div> -->
                    <div class="material-code" style="text-align: left;">{{ material.materialCode }}</div>
                    <div class="material-code" style="text-align: left;">{{ material.batch }}</div>
                    <div class="material-code" style="text-align: left;">{{ material.syscode }}</div>
                  </div>
                  <div v-else>
                    <!-- <img :src="editIcon" alt="编辑" style="position: absolute;right: -6px;top: -6px;width: 16px;height: 16px;"> -->
                    <div class="material-name" style="text-align: left;">{{ material.partName }}</div>
                    <div class="material-name" style="text-align: left;">{{ material.materialName }}</div>
                    <div style="text-align: left;">{{ material.specDesc }}</div>
                    <!-- <div class="material-code" style="text-align: left;">{{ material.contractCode }}</div> -->
                    <div class="material-code" style="text-align: left;">{{ material.materialCode }}</div>
                    <div class="material-code" style="text-align: left;">{{ material.batch }}</div>
                    <div class="material-code" style="text-align: left;">{{ material.syscode }}</div>
                  </div>
                </div>
                <div
                  class="item-content"
                  style="width: 13%;"
                >
                  <template v-if="material.type === 0">
                    <!-- <div class="material-name" style="text-align: left;padding-left: 6px;border-left: 3px solid #D2475D;line-height: 1;margin-bottom: 4px;">下单状态</div> -->
                    <div class="material-name" style="text-align: left;">
                      料单预估 <span class="material-code">
                        {{ formatOneDecimal(material.bomEstimate) || '/' }}
                        <template v-if="material.bomEstimate">{{ material.bomEstimateUnit }}</template>
                      </span>
                    </div>
                    <div style="text-align: left;">
                      采购中 <span class="material-code">
                        {{ formatOneDecimal(material.purchasing) || '/' }}
                        <template v-if="material.purchasing">{{ material.purchasingUnit }}</template>
                      </span>
                    </div>
                    <div class="material-name" style="text-align: left;">
                      库存 <span class="material-code">
                        {{ formatOneDecimal(material.inventory) || '/' }}
                        <template v-if="material.inventory">{{ material.inventoryUnit }}</template>
                      </span>
                    </div>
                  </template>
                </div>
                <div class="item-content" style="width: 6%;">
                  <template v-if="isFactoryMaterialPurchase">
                    <v-tooltip
                      v-if="material.productCodes && material.productCodes.length > 0"
                      location="top"
                      max-width="360"
                    >
                      <template #activator="{ props: tipProps }">
                        <span v-bind="tipProps" class="purchase-associated-products-tip-wrap">
                          <img
                            :src="inputTipImg"
                            alt="关联产品"
                            class="purchase-associated-products-tip-img"
                          />
                          <span class="purchase-associated-products-count" v-if="material.productCodes?.length > 0">
                            {{ material.productCodes?.length }}件
                          </span>
                        </span>
                      </template>
                      <div class="purchase-associated-products-tooltip">
                        <div
                          v-for="(productCode, pcIdx) in material.productCodes"
                          :key="pcIdx"
                        >
                          {{ productCode }}
                        </div>
                      </div>
                    </v-tooltip>
                    <span v-else>/</span>
                  </template>
                  <template v-else-if="isRequisitionSummaryPurchase">
                    <div
                      class="purchase-associated-products-editable"
                      @click.stop="!isMaterialReadonly(material) && openAssociatedProductsDialog(material)"
                    >
                      <div class="purchase-associated-products-editable-text">
                        <template v-if="material.productCodes && material.productCodes.length > 0">
                          <div
                            v-for="(productCode, pcIdx) in material.productCodes"
                            :key="pcIdx"
                            class="purchase-associated-product-line"
                          >
                            {{ productCode }}
                          </div>
                        </template>
                        <span v-else class="purchase-associated-placeholder">/</span>
                      </div>
                      <img
                        v-if="!isMaterialReadonly(material)"
                        :src="editIcon"
                        alt="编辑关联产品"
                        class="purchase-associated-products-edit-icon"
                      />
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="material.productCodes.length > 0">
                      <div v-for="productCode in material.productCodes" :key="productCode">
                        <div style="margin-bottom: 4px;">{{ productCode }}</div>
                      </div>
                    </template>
                    <template v-else>
                      {{ '/' }}
                    </template>
                  </template>
                </div>
                <div class="item-content" style="width: 11%;">
                  <v-text-field
                    v-model="material.materialCount"
                    label="数量"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    type="number"
                    @wheel="preventNumberInputWheel"
                    @input="handleQuantityInput(material,index)"
                    :readonly="isMaterialReadonly(material)"
                    :class="isMaterialReadonly(material) ? 'v-field--readonly' : ''"
                  />
                </div>

                <!-- :readonly="!!material._originalMaterialUnit"
                :class="material._originalMaterialUnit ? 'v-field--readonly' : ''" -->
                <div class="item-content" style="width: 100px;">
                  <v-select
                    v-model="material.materialUnit"
                    :items="getUnitListByBigClassOrSmallClass(material.bigClass, material.smallClass)"
                    label="单位"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    item-title="unitName"
                    item-value="unitName"
                    return-object
                    :readonly="isMaterialReadonly(material)"
                    :class="isMaterialReadonly(material) ? 'v-field--readonly' : ''"
                  />
                </div>
                <div class="item-content" style="width: 100px;">
                  <v-text-field
                    v-model="material.materialPrice"
                    label="单价"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details
                    type="number"
                    @wheel="preventNumberInputWheel"
                    @input="handlePriceInput(material,index)"
                  />
                </div>
                  <!-- :readonly="isMaterialReadonly(material)"
                  :class="isMaterialReadonly(material) ? 'v-field--readonly' : ''" -->
                <div class="item-content" style="width: 13%;">
                  <v-text-field
                    :model-value="calculateTotalPrice(material.materialPrice, material.materialCount)"
                    label="金额"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    type="number"
                    @wheel="preventNumberInputWheel"
                    class="v-field--readonly"
                    readonly
                  />
                </div>
                <div class="item-content">
                  <v-textarea
                    v-model="material.remark"
                    label="备注"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details
                    rows="1"
                    resize
                    auto-grow
                    maxlength="100"
                    :readonly="isMaterialReadonly(material)"
                    :class="isMaterialReadonly(material) ? 'v-field--readonly' : ''"
                  ></v-textarea>
                </div>
                <div class="item-content" style="width: 180px;position:relative" v-if="!(material._isExtraExpense || isExpenseType(material.materialName))">
                  <v-text-field
                    v-model="material.plannedDeliveryDate"
                    label="计划交货"
                    persistent-placeholder
                    variant="outlined"
                    density="compact"
                    hide-details="auto"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    :class="isMaterialReadonly(material) ? 'v-field--readonly native-date-field' : 'native-date-field'"
                    @click="!isMaterialReadonly(material) && openMaterialDatePicker(index)"
                  />
                  <input
                    v-if="!isMaterialReadonly(material)"
                    :ref="el => setMaterialDateInputRef(el, index)"
                    type="date"
                    :value="material.plannedDeliveryDate"
                    style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
                    @change="(e) => onMaterialDateChange(e, index)"
                  />
                  <!-- :min="getTodayDate()" -->
                </div>
                <div class="item-content" style="width: 180px;" v-else></div>
                <div class="item-content" style="width: 40px;display: flex;justify-content: center;align-items: center;"
                  v-if="!isMaterialReadonly(material)"
                >
                  <v-btn
                    icon="mdi-delete"
                    color="error"
                    variant="text"
                    density="compact"
                    size="small"
                    @click="deleteMaterial(index)"
                  />
                </div>
                <div class="item-content" style="width: 40px;" v-else></div>
              </div>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-end">
          <v-btn
            color="error"
            variant="tonal"
            @click="handleClose"
          >
            取消
          </v-btn>
          <v-btn v-if="purchaseData.purchaseOrderNo" color="primary" variant="flat" @click="openAddPurchaseItemDialog">增加采购项</v-btn>
          <v-btn color="primary" variant="flat" @click="setAllDeliveryTime">
            批量设置交期
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            @click="submitPurchase"
            :loading="purchaseLoading"
          >
            确定
          </v-btn>
          <v-btn color="primary" variant="flat" @click="addExpense">
            增加费用
          </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="materialFieldDialogVisible"
    max-width="700"
  >
    <v-card class="purchase-dialog">
      <v-card-title class="d-flex justify-space-between align-center">
        <span>编辑采购项信息</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="materialFieldDialogVisible = false"
        />
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6" v-if="editingMaterialRef && editingMaterialRef.partName && editingMaterialRef.partName != '/'">
            <v-text-field
              v-model="materialFieldForm.partName"
              label="零件名称"  
              persistent-placeholder
              variant="outlined"
              density="compact"
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" sm="6" v-if="editingMaterialRef">
            <v-text-field
              v-model="materialFieldForm.materialName"
              label="名称"
              persistent-placeholder
              variant="outlined"
              density="compact"
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" sm="6" v-if="editingMaterialRef">
            <v-text-field
              v-model="materialFieldForm.specDesc"
              label="规格型号"
              persistent-placeholder
              variant="outlined"
              density="compact"
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" sm="6" v-if="editingMaterialRef">
            <v-text-field
              v-model="materialFieldForm.materialCode"
              label="编码"
              persistent-placeholder
              variant="outlined"
              density="compact"
              hide-details="auto"
            />
          </v-col>
          <!-- <v-col cols="12" sm="6" v-if="editingMaterialRef">
            <v-text-field
              v-model="materialFieldForm.batch"
              label="批号"
              persistent-placeholder
              variant="outlined"
              density="compact"
              hide-details="auto"
            />
          </v-col>
          <v-col cols="12" sm="6" v-if="editingMaterialRef">
            <v-text-field
              v-model="materialFieldForm.syscode"
              label="客户编号"
              persistent-placeholder
              variant="outlined"
              density="compact"
              hide-details="auto"
            />
          </v-col> -->
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" variant="tonal" @click="materialFieldDialogVisible = false">取消</v-btn>
        <v-btn color="primary" variant="flat" @click="confirmMaterialFieldDialog">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- 请购单发起：编辑关联产品（合同产品列表 + 关键词） -->
  <v-dialog
    v-model="associatedProductsDialogVisible"
    max-width="800"
    scrollable
  >
    <v-card class="purchase-dialog">
      <v-card-title class="d-flex justify-space-between align-center">
        <span>关联产品</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="associatedProductsDialogVisible = false"
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex gap-2 mb-4 align-center flex-wrap">
          <v-text-field
            v-model="associatedProductKeyword"
            label="关键词搜索"
            placeholder="客户品号/唯一码/简称"
            persistent-placeholder
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="flex-grow-1"
            style="min-width: 200px;"
            @keyup.enter="loadAssociatedContractProducts"
          />
          <v-btn
            color="primary"
            variant="flat"
            :loading="associatedProductLoading"
            @click="loadAssociatedContractProducts"
          >
            查询
          </v-btn>
        </div>
        <div v-if="associatedProductLoading" class="text-center py-6" style="color: rgba(255,255,255,0.7);">
          加载中…
        </div>
        <v-table v-else class="contract-table purchase-associated-product-table" density="compact">
          <thead>
            <tr>
              <th style="width: 44px;" class="text-center"></th>
              <th class="text-left" style="width: 120px;">客户品号</th>
              <th class="text-left" style="width: 60px;">唯一码</th>
              <th class="text-left" style="width: 120px;">简称</th>
              <!-- <th class="text-left">批号</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-if="associatedProductList.length === 0">
              <td colspan="5" class="text-center py-6" style="color: rgba(255,255,255,0.55);">
                暂无数据，请调整关键词后查询
              </td>
            </tr>
            <tr
              v-for="(row, ri) in associatedProductList"
              :key="row.id ?? ri"
            >
              <td class="text-center">
                <v-checkbox
                  :model-value="isAssociatedProductRowSelected(row)"
                  hide-details
                  density="compact"
                  color="primary"
                  @update:model-value="() => toggleAssociatedProductRow(row)"
                />
              </td>
              <td class="text-left" style="word-break: break-all;word-wrap: break-word;">{{ row.syscode || '/' }}</td>
              <td class="text-left" style="word-break: break-all;word-wrap: break-word;">{{ row.code || '/' }}</td>
              <td class="text-left" style="word-break: break-all;word-wrap: break-word;">{{ row.nameShort || row.name || '/' }}</td>
              <!-- <td class="text-left">{{ row.batch || '/' }}</td> -->
            </tr>
          </tbody>
        </v-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" variant="tonal" @click="associatedProductsDialogVisible = false">
          取消
        </v-btn>
        <v-btn color="primary" variant="flat" @click="confirmAssociatedProductsSelection">
          确定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- 批量设置交期弹窗 -->
  <v-dialog
    v-model="batchDateDialogVisible"
    max-width="360"
    persistent
  >
    <v-card class="purchase-dialog">
      <v-card-title class="d-flex justify-space-between align-center">
        <span>批量设置交期</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="batchDateDialogVisible = false"
        />
      </v-card-title>
      <v-card-text>
        <div class="native-date-wrapper">
          <v-text-field
            v-model="batchDateValue"
            label="选择日期"
            persistent-placeholder
            variant="outlined"
            density="compact"
            hide-details="auto"
            prepend-inner-icon="mdi-calendar"
            readonly
            class="native-date-field"
            @click="openBatchDatePicker"
          />
          <!-- :min="getTodayDate()" -->
          <input
            ref="batchDateInputRef"
            type="date"
            :value="batchDateValue"
            style="position: absolute; left: 0; top: 100%; opacity: 0; pointer-events: none; width: 100%; height: 1px; z-index: 9999;"
            @change="onBatchDateChange"
          />
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="error" variant="tonal" @click="batchDateDialogVisible = false">
          取消
        </v-btn>
        <v-btn color="primary" variant="flat" @click="confirmBatchDate">
          确定
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- 增加采购项弹窗 -->
  <v-dialog
    v-model="addPurchaseItemDialogVisible"
    max-width="1200"
    height="80vh"
    scrollable
    persistent
  >
    <v-card class="purchase-dialog">
      <v-card-title class="d-flex justify-space-between align-center">
        <span>增加采购项</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="closeAddPurchaseItemDialog"
        />
      </v-card-title>
      <v-card-text>
        <div class="d-flex gap-2 mb-4 align-center flex-wrap justify-space-between">
          <v-text-field
            v-model="addPurchaseItemKeyword"
            label="关键字搜索"
            placeholder="合同名称/合同号/供应商/物料名称/产品号"
            persistent-placeholder
            variant="outlined"
            density="compact"
            hide-details
            class="flex-grow-1"
            append-inner-icon="mdi-magnify"
            clearable
            style="width:400px;max-width:450px;"
            @click:clear="loadAddPurchaseItemList()"
            @keyup.enter="loadAddPurchaseItemList()"
            @click:append-inner="loadAddPurchaseItemList()"
          />
          <!-- <v-btn
            color="primary"
            variant="flat"
            :loading="addPurchaseItemLoading"
            @click="loadAddPurchaseItemList"
          >
            查询
          </v-btn> -->
          <v-btn-toggle
            v-model="addPurchaseItemType"
            mandatory
            class="search-type-toggle"
            density="compact"
            @update:model-value="loadAddPurchaseItemList"
          >
            <div class="button-group">
              <v-btn :value="0" variant="text" class="toggle-button">物料</v-btn>
              <v-btn :value="1" variant="text" class="toggle-button">产品</v-btn>
            </div>
          </v-btn-toggle>
        </div>

        <div v-if="addPurchaseItemLoading" class="text-center py-6" style="color: rgba(255,255,255,0.7);">
          加载中…
        </div>
        <div v-else-if="addPurchaseItemList.length === 0" class="text-center py-6" style="color: rgba(255,255,255,0.55);">
          暂无数据，请调整关键词后查询
        </div>
        <div v-else class="add-purchase-item-list">
          <div class="add-purchase-item-header">
            <div class="item-content" style="width: 14%; text-align: left;">采购项</div>
            <div class="item-content" style="width: 12%; text-align: left;">下单状态</div>
            <div class="item-content" style="width: 12%; text-align: left;">关联产品</div>
            <div class="item-content text-center" style="width: 7%;">数量</div>
            <div class="item-content text-center" style="width: 70px;">单位</div>
            <div class="item-content text-center" style="width: 80px;">单价</div>
            <div class="item-content text-center" style="width: 10%;">金额</div>
            <div class="item-content text-center" style="flex: 1;">备注</div>
            <div class="item-content text-center" style="width: 100px;">计划交货</div>
            <div style="width: 44px; text-align: center;"></div>
          </div>
          <div class="add-purchase-item-body">
            <div
              v-for="(row, ri) in addPurchaseItemList"
              :key="getAddPurchaseItemRowKey(row, ri)"
              class="add-purchase-item-row"
            >
              <!-- 采购项 -->
              <div class="item-content" style="width: 14%; text-align: left;">
                <div v-if="row.partName" class="material-name">{{ row.partName }}</div>
                <div v-if="row.goodsName || row.materialName" class="material-name">{{ row.goodsName || row.materialName }}</div>
                <div v-if="row.goodsSpec || row.materialSpec || row.specDesc">{{ row.goodsSpec || row.materialSpec || row.specDesc }}</div>
                <div class="material-code" v-if="row.goodsNo || row.materialCode">{{ row.goodsNo || row.materialCode }}</div>
                <div class="material-code" v-if="row.batch">{{ row.batch }}</div>
                <div class="material-code" v-if="row.syscode">{{ row.syscode }}</div>
              </div>
              <!-- 下单状态 -->
              <div class="item-content" style="width: 12%; text-align: left;">
                <div class="material-name">
                  料单预估 <span class="material-code">{{ formatOneDecimal(row.bomEstimate) || '/' }}</span>
                  <span class="material-code" v-if="row.bomEstimate">{{ row.bomEstimateUnit }}</span>
                </div>
                <div>
                  采购中 <span class="material-code">{{ formatOneDecimal(row.purchasing) || '/' }}</span>
                  <span class="material-code" v-if="row.purchasing">{{ row.purchasingUnit }}</span>
                </div>
                <div class="material-name">
                  库存 <span class="material-code">{{ formatOneDecimal(row.inventory) || '/' }}</span>
                  <span class="material-code" v-if="row.inventory">{{ row.inventoryUnit }}</span>
                </div>
              </div>
              <!-- 关联产品 -->
              <div class="item-content" style="width: 12%; text-align: left;">
                <template v-if="getRowProductCodeList(row).length > 0">
                  <div v-for="code in getRowProductCodeList(row)" :key="code" class="product-code-line">
                    {{ code }}
                  </div>
                </template>
                <span v-else class="material-code">/</span>
              </div>
              <!-- 数量 -->
              <div class="item-content" style="width: 7%;">
                <template v-if="row.quantity != null && row.quantity !== ''">
                  {{ row.quantity }}
                </template>
                <template v-else>/</template>
              </div>
              <!-- 单位 -->
              <div class="item-content" style="width: 70px;">
                {{ getRowUnit(row) || '/' }}
              </div>
              <!-- 单价 -->
              <div class="item-content" style="width: 80px;">
                {{ formatMoney(row.price) }}
              </div>
              <!-- 金额 -->
              <div class="item-content" style="width: 10%;">
                {{ formatMoney(row.totalPrice) }}
              </div>
              <!-- 备注 -->
              <div class="item-content" style="flex: 1;">
                <span class="remark-text" :title="row.remark">{{ row.remark || '/' }}</span>
              </div>
              <!-- 计划交货 -->
              <div class="item-content" style="width: 100px;">
                {{ formatDateForNativeInput(row.plannedDeliveryDate) || '/' }}
              </div>
              <div style="width: 44px; text-align: center;">
                <v-checkbox
                  :model-value="isAddPurchaseItemSelected(row, ri)"
                  hide-details
                  density="compact"
                  color="primary"
                  @update:model-value="(v) => toggleAddPurchaseItemSelect(row, ri, !!v)"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div v-if="addPurchaseItemList.length > 0" class="custom-pagination d-flex align-center justify-space-between mt-4">
          <div class="pagination-info">
            共 {{ addPurchaseItemTotal }} 条记录
            <span v-if="addPurchaseItemSelectedIds.length > 0" class="ml-2" style="color: #D2475D;">
              已选 {{ addPurchaseItemSelectedIds.length }} 条
            </span>
          </div>
          <div class="d-flex align-center">
            <div class="pagination-controls">
              <v-btn
                icon="mdi-chevron-double-left"
                variant="text"
                density="comfortable"
                class="pagination-btn"
                :disabled="addPurchaseItemPage === 1"
                @click="addPurchaseItemPage = 1; loadAddPurchaseItemList()"
              />
              <v-btn
                icon="mdi-chevron-left"
                variant="text"
                density="comfortable"
                class="pagination-btn"
                :disabled="addPurchaseItemPage === 1"
                @click="addPurchaseItemPage--; loadAddPurchaseItemList()"
              />
              <span class="pagination-text mx-2">{{ addPurchaseItemPage }} / {{ totalAddPurchaseItemPages }}</span>
              <v-btn
                icon="mdi-chevron-right"
                variant="text"
                density="comfortable"
                class="pagination-btn"
                :disabled="addPurchaseItemPage === totalAddPurchaseItemPages || totalAddPurchaseItemPages === 0"
                @click="addPurchaseItemPage++; loadAddPurchaseItemList()"
              />
              <v-btn
                icon="mdi-chevron-double-right"
                variant="text"
                density="comfortable"
                class="pagination-btn"
                :disabled="addPurchaseItemPage === totalAddPurchaseItemPages || totalAddPurchaseItemPages === 0"
                @click="addPurchaseItemPage = totalAddPurchaseItemPages; loadAddPurchaseItemList()"
              />
            </div>
          </div>
        </div>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="error" variant="tonal" @click="closeAddPurchaseItemDialog">
          取消
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          :loading="addPurchaseItemConfirmLoading"
          @click="confirmAddPurchaseItems"
        >
          确定<span v-if="addPurchaseItemSelectedIds.length"> ({{ addPurchaseItemSelectedIds.length }})</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </div>
</template>

<script setup lang="ts">
import { ref, watch, nextTick, computed, onMounted, reactive } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import { purchaseApi, contractApi } from '@/services/api'
import editIcon from '@/assets/edit.png'
import inputTipImg from '@/assets/inputTip.png'

const { showError, showSuccess } = useSnackbar()

const props = defineProps<{
  warehouseOptions?: Array<{ warehouseNo: string; warehouseName: string; [k: string]: any }>
  allowWarehouseSelect?: boolean
  contractId?: number | string | null
  contractCode?: string | null
  projectName?: string | null
  contractIds?: number[] // 可选的合同ID列表，限制只能从这些合同发起采购；不传则不限制
}>()

const emit = defineEmits<{
  (e: 'success', payload: { requisitionId: number | null; requisitionIndex: number }): void
}>()

// 对外暴露：父组件通过 ref 调用，用于打开弹窗并注入请购单数据
const visible = ref(false)
const typeSelectVisible = ref(false) // 采购类型选择弹窗：先选类型再打开主弹窗
const currentRequisitionItem = ref<any>(null)
const currentRequisitionIndex = ref<number>(-1)
/** 常规材料（factoryMaterial）入口：关联产品列不逐条展示，用图标悬浮查看 */
const isFactoryMaterialPurchase = computed(
  () => currentRequisitionItem.value?._purchaseEntry === 'factoryMaterial'
)
/** 请购汇总页发起（PurchaseRequisition）：关联产品可编辑，弹窗拉取合同产品列表 */
const isRequisitionSummaryPurchase = computed(
  () => currentRequisitionItem.value?._purchaseEntry === 'requisition'
)

const associatedProductsDialogVisible = ref(false)
const associatedProductMaterialRef = ref<any>(null)
const associatedProductKeyword = ref('')
const associatedProductLoading = ref(false)
const associatedProductList = ref<any[]>([])
/** 选中的以 cp 开头的唯一码（与 code 字段一致，写入 material.productCodes） */
const associatedProductSelectedCodes = ref<string[]>([])

/** 唯一码：仅 code 且以 cp 开头（不区分大小写） */
function getCpUniqueCode(row: any): string {
  const c = String(row?.code ?? '').trim()
  if (!c || !/^cp/i.test(c)) return ''
  return c
}

function isAssociatedProductRowSelected(row: any) {
  const cp = getCpUniqueCode(row)
  if (!cp) return false
  return associatedProductSelectedCodes.value.includes(cp)
}

function toggleAssociatedProductRow(row: any) {
  const cp = getCpUniqueCode(row)
  if (!cp) {
    showError('仅支持选择以 cp 开头的唯一码')
    return
  }
  const arr = [...associatedProductSelectedCodes.value]
  const i = arr.indexOf(cp)
  if (i >= 0) arr.splice(i, 1)
  else arr.push(cp)
  associatedProductSelectedCodes.value = arr
}

async function loadAssociatedContractProducts() {
  associatedProductLoading.value = true
  try {
    const res = await purchaseApi.contractProductListByPurchase({
      page: 1,
      pageSize: 100,
      keyword: String(associatedProductKeyword.value || '').trim(),
      showAll: false
    })
    if (res?.code === 0 && res.data?.records) {
      associatedProductList.value = res.data.records
    } else {
      associatedProductList.value = []
      if (res?.code !== 0) {
        showError(res?.message || res?.msg || '加载产品列表失败')
      }
    }
  } catch (e: any) {
    associatedProductList.value = []
    showError(e?.message || '加载产品列表失败')
  } finally {
    associatedProductLoading.value = false
  }
}

function openAssociatedProductsDialog(material: any) {
  associatedProductMaterialRef.value = material
  const existing = normalizeProductCodesField(material.productCodes)
  associatedProductSelectedCodes.value = existing.filter(c => /^cp/i.test(String(c).trim()))
  associatedProductKeyword.value = ''
  associatedProductList.value = []
  associatedProductsDialogVisible.value = true
  void loadAssociatedContractProducts()
}

function confirmAssociatedProductsSelection() {
  const m = associatedProductMaterialRef.value
  if (m) {
    m.productCodes = [...associatedProductSelectedCodes.value].filter(c =>
      /^cp/i.test(String(c).trim())
    )
  }
  associatedProductsDialogVisible.value = false
  associatedProductMaterialRef.value = null
}

/** 接口可能返回 string[] 或逗号分隔字符串 */
function normalizeProductCodesField(v: any): string[] {
  if (Array.isArray(v)) return v.map((x) => String(x).trim()).filter(Boolean)
  if (v == null || v === '') return []
  if (typeof v === 'string') {
    return v
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
  }
  return []
}

const selectedMaterialDetails = ref<any[]>([])
const purchaseForm = ref()
const purchaseValid = ref(false)
const purchaseLoading = ref(false)
const vendorList = ref<any[]>([])
const vendorLoading = ref(false)
const vendorSearchText = ref('')
const materialDateInputRefs = ref<Record<number, HTMLInputElement | null>>({})
const unitOptions = ref<any[]>([])
const batchDateDialogVisible = ref(false)
const batchDateValue = ref('')
const batchDateInputRef = ref<HTMLInputElement | null>(null)

// 增加采购项弹窗相关
const addPurchaseItemDialogVisible = ref(false)
const addPurchaseItemLoading = ref(false)
const addPurchaseItemConfirmLoading = ref(false)
const addPurchaseItemKeyword = ref('')
const addPurchaseItemType = ref<0 | 1>(0)
const addPurchaseItemList = ref<any[]>([])
const addPurchaseItemPage = ref(1)
const addPurchaseItemPageSize = ref(10)
const addPurchaseItemTotal = ref(0)
const addPurchaseItemSelectedIds = ref<(number | string)[]>([])
const addPurchaseItemSelectedMap = ref<Map<string | number, any>>(new Map())

const totalAddPurchaseItemPages = computed(() =>
  Math.max(1, Math.ceil(addPurchaseItemTotal.value / addPurchaseItemPageSize.value))
)

const totalMaterialCount = computed(() =>
  selectedMaterialDetails.value.reduce((sum: number, material: any) => sum + (Number(material.materialCount) || 0), 0)
)

const preventNumberInputWheel = (event: WheelEvent) => {
  event.preventDefault()
  const target = event.target as HTMLInputElement | null
  target?.blur()
}

// 数字格式化：最多一位小数；没有小数则不显示 .0
const formatOneDecimal = (val: any) => {
  if (val === null || val === undefined || val === '') return ''
  const num = Number(val)
  if (Number.isNaN(num)) return String(val)
  const rounded = Math.round(num * 10) / 10
  const normalized = rounded === 0 ? 0 : rounded
  if (Number.isInteger(normalized)) {
    return String(normalized)
  }
  return normalized.toFixed(1)
}

// 收货仓库下拉数据：
// 1）优先使用父组件传入的 warehouseOptions
// 2）否则根据当前请购单 / 物料行里的仓库信息自动推导出一个去重列表
const warehouseSelectItems = computed(() => {
  const fromProps = props.warehouseOptions || []
  if (fromProps.length > 0) {
    return fromProps
  }

  const list: Array<{ warehouseNo: string; warehouseName: string }> = []

  const addOption = (no: any, name: any) => {
    const warehouseNo = String(no || '')
    const warehouseName = String(name || '')
    if (!warehouseNo && !warehouseName) return
    if (list.find(item => item.warehouseNo === warehouseNo && item.warehouseName === warehouseName)) return
    list.push({ warehouseNo, warehouseName })
  }

  if (currentRequisitionItem.value) {
    addOption(currentRequisitionItem.value.warehouseNo, currentRequisitionItem.value.warehouseName)
  }

  selectedMaterialDetails.value.forEach((row: any) => {
    addOption(row.warehouseNo, row.warehouseName)
  })

  if (list.length === 0 && purchaseData.value.warehouse) {
    addOption(purchaseData.value.warehouse.warehouseNo, purchaseData.value.warehouse.warehouseName)
  }

  return list
})

const physicalPurchaseDefaultRemark =
  '1、贵公司提供产品保质期最少不得低于二年\n2、凡因供货厂商质量上与我司要求标准有所差异造成的后果，除扣除货款之外还需要负起我司其它之一切损失\n3、供货厂商未依规定期间交货，若因此造成我司所有经济及其名誉上的损失，我司将追究一切之责任\n4、收到清单请及时确认交货期并回传\n5、每周六提供所有订单的交货排程'

const purchaseData = ref({
  purchaseType: 0 as 0 | 1, // 0 实物采购，1 服务采购
  vendor: null as any,
  quantity: null as number | null,
  price: null as number | null,
  purchaseOrderNo: null as string | null,
  paymentMethod: { value: '0', label: '预付' },
  paymentDate: null as string | null,
  paymentCompany: null as any,
  id: null as number | null,
  totalAmount: 0,
  tax: { value: '1', label: '含税' },
  taxRate: { value: '0', label: '0%' } as any,
  taxAmount: 0,
  totalAmountWithTax: 0,
  warehouse: { warehouseNo: '', warehouseName: '' } as any,
  purchaseStandard: null as string | null,
  deliveryAddress: '' as string,
  purchaseNo: null as string | null,
  remark: physicalPurchaseDefaultRemark,
})

const paymentMethods = [
  { value: '0', label: '预付' },
  { value: '1', label: '现付' },
  { value: '2', label: '月结' },
  { value: '3', label: '次月结' },
]

const purchaseStandardList = [
  'GB/T16799-2018',
  'GB 18401-2010中B级规范',
  'GB 18583-2008有害物质限量',
  '符合39600-2021(EO)(ENF)甲醛释放量',
  'GB/T10802-2023(视产品订定)华为卡座S级其它家具A级',
  'GB/T8624-2012',
  'GB/T9846-2015标准和GB/T14732-2017(环保)',
  'GB/T41919-2020',
  'GB 18581-2020',
  'GB/T44437-2024',
]

const paymentCompanys = [
  { value: '优罗莎', label: '优罗莎' },
  { value: '上海江丰', label: '上海江丰' },
]

const taxs = [
  { value: '0', label: '不含税' },
  { value: '1', label: '含税' },
]

const taxRates = [
  { value: '0', label: '0%' },
  { value: '3', label: '3%' },
  { value: '6', label: '6%' },
  { value: '13', label: '13%' },
]

const expenseTypePurchaseOptions = ['维修费', '运费', '服务费','委外','模具费','安装费','办公用品','销货赔偿','雕花车木','折让费','其他费','商检费','提货费','运输费','快递费','样品费']

const isExpenseType = (materialName: string): boolean => {
  return expenseTypePurchaseOptions.includes(materialName)
}

// 计算采购单总金额、税额和含税总金额
const calculatePurchaseTotalAmount = () => {
  const total = selectedMaterialDetails.value.reduce((sum, material) => {
    const quantity = Number(material.materialCount) || 0
    const price = Number(material.materialPrice) || 0
    return sum + quantity * price
  }, 0)
  purchaseData.value.totalAmount = Number(total.toFixed(2))
  calculateTaxAmount()
}

// 计算税额和含税总金额
const calculateTaxAmount = () => {
  const totalAmount = purchaseData.value.totalAmount || 0
  const taxRateValue = Number(purchaseData.value.taxRate?.value) || 0

  if (Number(purchaseData.value.tax?.value ?? '0') === 0) {
    const taxAmount = (totalAmount * taxRateValue) / 100
    purchaseData.value.taxAmount = Number(taxAmount.toFixed(2))
    purchaseData.value.totalAmountWithTax = Number((totalAmount + taxAmount).toFixed(2))
  } else {
    const taxAmount = totalAmount - totalAmount / (1 + taxRateValue / 100)
    purchaseData.value.taxAmount = Number(taxAmount.toFixed(2))
    purchaseData.value.totalAmountWithTax = Number(totalAmount)
  }
}

// 监听物料详情变化，自动计算总金额
watch(
  selectedMaterialDetails,
  () => {
    calculatePurchaseTotalAmount()
  },
  { deep: true },
)

// 监听税率、含税标识变化
watch(
  () => purchaseData.value.taxRate,
  () => {
    calculateTaxAmount()
  },
  { deep: true },
)

watch(
  () => purchaseData.value.tax,
  () => {
    calculateTaxAmount()
  },
  { deep: true },
)

// 监听供应商选择变化，设置默认付款方式与税率
watch(
  () => purchaseData.value.vendor,
  newVendor => {
    if (newVendor && newVendor.paymentType !== undefined && newVendor.paymentType !== null) {
      const paymentTypeValue = String(newVendor.paymentType)
      const matchedPaymentMethod = paymentMethods.find(item => item.value === paymentTypeValue)
      if (matchedPaymentMethod) {
        purchaseData.value.paymentMethod = matchedPaymentMethod
      }
    }
    if (newVendor && newVendor.rate !== undefined && newVendor.rate !== null) {
      const rateValue = String(newVendor.rate)
      const matchedRate = taxRates.find(item => item.value === rateValue)
      if (matchedRate) {
        purchaseData.value.taxRate = matchedRate
      }
    }
  },
)

// 监听供应商搜索文本变化
watch(
  vendorSearchText,
  async (newVal: string) => {
    if (!newVal || newVal.trim() === '') {
      vendorList.value = []
      return
    }
    try {
      vendorLoading.value = true
      const res = await purchaseApi.vendorList({
        page: 1,
        pageSize: 100,
        keyword: vendorSearchText.value || '',
      })
      if (res?.code === 0 && res.data) {
        vendorList.value = res.data.records
      }
    } catch (error) {
      console.error('加载供应商列表失败:', error)
    } finally {
      vendorLoading.value = false
    }
  },
  { immediate: false },
)

// 获取今天日期
const getTodayDate = () => {
  const today = new Date()
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

// 设置物料日期选择器引用
const setMaterialDateInputRef = (el: any, index: number) => {
  if (el) {
    materialDateInputRefs.value[index] = el
  }
}

// 打开物料的日期选择器
const openMaterialDatePicker = (index: number) => {
  nextTick(() => {
    const input = materialDateInputRefs.value[index]
    if (input) {
      if (typeof (input as any).showPicker === 'function') {
        ;(input as any).showPicker()
      } else {
        input.click()
      }
    }
  })
}

// 加载单位列表
const loadUnitList = async () => {
  try {
    const res = await contractApi.getUnitList()
    if (res?.code === 0 && res.data) {
      unitOptions.value = res.data
    }
  } catch (error) {
    console.error('加载单位列表失败:', error)
  }
}

// 根据大类或小类获取可使用的单位
const getUnitListByBigClassOrSmallClass = (bigClass: string, smallClass: string) => {
  return unitOptions.value.map((item: any) => item.unitName)
}

// 物料日期选择变化处理
const onMaterialDateChange = (event: Event, index: number) => {
  const target = event.target as HTMLInputElement
  const newDate = target.value

  try {
    if (newDate && typeof newDate === 'string') {
      const material = selectedMaterialDetails.value[index]
      if (material) {
        material.plannedDeliveryDate = newDate
      }
    }
  } catch (error) {
    console.error('物料日期处理失败:', error)
  }
}

// 日期转时间戳
const dateTimestamp = (date: string | null) => {
  if (!date) return null
  return new Date(date).getTime()
}

// 日期转 YYYY-MM-DD（用于编辑回显）
const formatDateForNativeInput = (val: number | string | null | undefined): string => {
  if (val == null || val === '') return ''
  try {
    const date = typeof val === 'number' ? new Date(val) : new Date(val)
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, '0')
    const d = String(date.getDate()).padStart(2, '0')
    return `${y}-${m}-${d}`
  } catch {
    return ''
  }
}

// 关闭采购类型选择弹窗（不打开主弹窗）
const closeTypeSelect = () => {
  typeSelectVisible.value = false
}

// 选择采购类型后打开主弹窗
const selectPurchaseType = (type: 0 | 1) => {
  purchaseData.value.purchaseType = type
  if (type === 0) {
    purchaseData.value.purchaseStandard = purchaseData.value.purchaseStandard ?? null
    purchaseData.value.deliveryAddress = ''
    purchaseData.value.remark = physicalPurchaseDefaultRemark
  } else {
    purchaseData.value.purchaseStandard = null
    purchaseData.value.deliveryAddress = purchaseData.value.deliveryAddress || ''
    purchaseData.value.remark = physicalPurchaseDefaultRemark
  }
  typeSelectVisible.value = false
  visible.value = true
}

// 重置采购数据为默认值
const resetPurchaseData = () => {
  purchaseData.value = {
    purchaseType: 0,
    vendor: null,
    paymentCompany: null,
    quantity: null,
    price: null,
    purchaseOrderNo: null,
    paymentMethod: { value: '0', label: '预付' },
    paymentDate: null,
    id: null,
    totalAmount: 0,
    tax: { value: '1', label: '含税' },
    taxRate: { value: '0', label: '0%' },
    taxAmount: 0,
    totalAmountWithTax: 0,
    warehouse: { warehouseNo: '', warehouseName: '' } as any,
    purchaseStandard: null,
    deliveryAddress: '',
    purchaseNo: null,
    remark: physicalPurchaseDefaultRemark,
  }
  materialDateInputRefs.value = {}
  vendorSearchText.value = ''
}

onMounted(() => {
  loadUnitList()
})

const addExpense = () => {
  selectedMaterialDetails.value.push({
    id: null,
    requisitionId: currentRequisitionItem.value?.id ?? null,
    materialCode: '',
    contractCode: '',
    batch: '',
    syscode: '',
    materialName: '',
    specDesc: '',
    materialUnit: '',
    _originalMaterialUnit: null,
    brand: '',
    materialCount: null,
    materialPrice: null,
    remark: '',
    plannedDeliveryDate: '',
    warehouseName: purchaseData.value.warehouse?.warehouseName || '',
    warehouseNo: purchaseData.value.warehouse?.warehouseNo || '',
    type: 1,
    _isExtraExpense: true,
    materialRemark: '',
    materialType: '',
    bigClass: '',
    smallClass: '',
    productCodes: [],
  })
}

// 统一设置交期
const setAllDeliveryTime = () => {
  // batchDateValue.value = getTodayDate()
  batchDateDialogVisible.value = true
}

const openBatchDatePicker = () => {
  nextTick(() => {
    const input = batchDateInputRef.value
    if (input) {
      if (typeof (input as any).showPicker === 'function') {
        ;(input as any).showPicker()
      } else {
        input.click()
      }
    }
  })
}

const onBatchDateChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  if (target.value) {
    batchDateValue.value = target.value
  }
}

const formatNumberUse = (num: number | string | null | undefined, decimals: number = 4): string => {
  if (num === null || num === undefined || num === '') {
    return ''
  }
  const n = typeof num === 'string' ? parseFloat(num) : num
  if (isNaN(n)) {
    return ''
  }
  return parseFloat(n.toFixed(decimals)).toString()
}

const confirmBatchDate = () => {
  if (!batchDateValue.value) {
    showError('请选择日期')
    return
  }
  selectedMaterialDetails.value.forEach((material: any) => {
    if (material && !isMaterialReadonly(material)) {
      material.plannedDeliveryDate = batchDateValue.value
    }
  })
  batchDateDialogVisible.value = false
}

const isMaterialReadonly = (material: any): boolean => {
  return Number(material.warehouseStatus) === 1
}

const deleteMaterial = (index: number) => {
  // console.log('selectedMaterialDetails', selectedMaterialDetails.value)
  // if (index < 0 || index >= selectedMaterialDetails.value.length) return
  const target = selectedMaterialDetails.value[index]
  if (target && isMaterialReadonly(target)) {
    showError('已入库的采购项不可删除')
    return
  }
  // 只允许删除额外费用行，避免误删主物料
  // if (!target || !target._isExtraExpense) return
  selectedMaterialDetails.value.splice(index, 1)
}

// ========== 增加采购项弹窗相关 ==========

function getAddPurchaseItemRowKey(row: any, index: number): string | number {
  return row.itemId ?? row.id ?? row.purchaseOrderId ?? row.orderId ?? `${row.productCodes ?? ''}_${row.quantity ?? ''}_${index}`
}

function isAddPurchaseItemSelected(row: any, index: number): boolean {
  const key = getAddPurchaseItemRowKey(row, index)
  return addPurchaseItemSelectedIds.value.includes(key)
}

function toggleAddPurchaseItemSelect(row: any, index: number, checked: boolean) {
  const key = getAddPurchaseItemRowKey(row, index)
  const arr = [...addPurchaseItemSelectedIds.value]
  const i = arr.indexOf(key)
  if (checked && i < 0) {
    arr.push(key)
    addPurchaseItemSelectedMap.value.set(key, row)
  }
  if (!checked && i >= 0) {
    arr.splice(i, 1)
    addPurchaseItemSelectedMap.value.delete(key)
  }
  addPurchaseItemSelectedIds.value = arr
}

function getRowUnit(row: any) {
  return row.unit || row.purchasingUnit || row.bomEstimateUnit || ''
}

function getRowProductCodeList(row: any): string[] {
  return normalizeProductCodesField(row.productCodes)
}

function formatMoney(v: unknown) {
  if (v === null || v === undefined || v === '') return '/'
  const n = Number(v)
  if (Number.isNaN(n)) return '/'
  return n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

const loadAddPurchaseItemList = async () => {
  addPurchaseItemLoading.value = true
  try {
    const params: Record<string, unknown> = {
      page: addPurchaseItemPage.value,
      pageSize: addPurchaseItemPageSize.value,
      keyword: addPurchaseItemKeyword.value,
      purchaseItemType: addPurchaseItemType.value,
      orderStatus: 0,
    }
    const res: any = await purchaseApi.purchaseItemList(params)
    if (res?.code === 0) {
      addPurchaseItemList.value = Array.isArray(res.data?.records) ? res.data.records : []
      addPurchaseItemTotal.value = res.data?.total || 0
    } else {
      addPurchaseItemList.value = []
      addPurchaseItemTotal.value = 0
      showError(res?.message || res?.msg || '获取采购项列表失败')
    }
  } catch (e: any) {
    console.error(e)
    addPurchaseItemList.value = []
    addPurchaseItemTotal.value = 0
    showError(e?.message || '获取采购项列表失败')
  } finally {
    addPurchaseItemLoading.value = false
  }
}

const openAddPurchaseItemDialog = () => {
  addPurchaseItemDialogVisible.value = true
  addPurchaseItemKeyword.value = ''
  addPurchaseItemType.value = purchaseData.value.purchaseType === 0 ? 0 : 1
  addPurchaseItemPage.value = 1
  addPurchaseItemSelectedIds.value = []
  addPurchaseItemSelectedMap.value = new Map()
  loadAddPurchaseItemList()
}

const closeAddPurchaseItemDialog = () => {
  addPurchaseItemDialogVisible.value = false
  addPurchaseItemKeyword.value = ''
  addPurchaseItemPage.value = 1
  addPurchaseItemSelectedIds.value = []
  addPurchaseItemSelectedMap.value = new Map()
  addPurchaseItemList.value = []
  addPurchaseItemTotal.value = 0
}

const confirmAddPurchaseItems = async () => {
  if (addPurchaseItemSelectedIds.value.length === 0) {
    showError('请至少选择一条采购项')
    return
  }

  const selected = Array.from(addPurchaseItemSelectedMap.value.values())
  if (selected.length === 0) {
    showError('请至少选择一条采购项')
    return
  }

  // 检查仓库一致性
  const currentWarehouseNo = purchaseData.value.warehouse?.warehouseNo
  for (const row of selected) {
    const rowWarehouseNo = row.warehouseNo
    if (currentWarehouseNo && rowWarehouseNo && String(currentWarehouseNo) !== String(rowWarehouseNo)) {
      showError('选中的采购项收货仓库与当前采购单不一致')
      return
    }
  }

  addPurchaseItemConfirmLoading.value = true
  try {
    const materialCodes: string[] = []

    for (const row of selected) {
      const newItem: any = {
        id: row.itemId ?? row.id ?? null,
        requisitionId: row.requisitionId ?? null,
        materialCode: row.goodsNo || row.materialCode || '',
        contractCode: row.contractCode || row.contractNo || '',
        batch: row.batch || '',
        syscode: row.syscode || '',
        materialName: row.goodsName || row.materialName || '',
        specDesc: row.goodsSpec || row.materialSpec || row.specDesc || '',
        materialUnit: row.unit || row.purchasingUnit || row.bomEstimateUnit || '',
        _originalMaterialUnit: row.unit || row.purchasingUnit || row.bomEstimateUnit || null,
        brand: row.brand || '',
        materialTotalCount: row.quantity ?? null,
        materialCount: row.quantity != null ? formatNumberUse(row.quantity, 4) : null,
        materialPrice: row.price != null ? row.price : row.materialPrice ?? null,
        remark: row.remark || '',
        plannedDeliveryDate: formatDateForNativeInput(row.plannedDeliveryDate),
        warehouseName: row.warehouseName || purchaseData.value.warehouse?.warehouseName || '',
        warehouseNo: row.warehouseNo || purchaseData.value.warehouse?.warehouseNo || '',
        type: Number(row.type ?? 0),
        materialRemark: row.materialRemark,
        materialType: row.materialType,
        bigClass: row.bigClass,
        smallClass: row.smallClass,
        bomKey: row.bomKey,
        partName: row.partName || '',
        contractNo: row.contractNo,
        contractId: row.contractId,
        productCodes: normalizeProductCodesField(row.productCodes),
        purchaseItemId: row.id ?? null,
      }
      selectedMaterialDetails.value.push(newItem)
      if (newItem.materialCode) {
        materialCodes.push(newItem.materialCode)
      }
    }

    // 为新添加的物料获取下单状态信息
    if (materialCodes.length > 0 && purchaseData.value.warehouse?.warehouseNo) {
      const res = await purchaseApi.purchaseProductQuantityInfo({
        materialCodes: materialCodes.join(','),
        warehouseNo: purchaseData.value.warehouse.warehouseNo,
      })
      if (res?.code === 0 && res.data) {
        selectedMaterialDetails.value.forEach((row: any) => {
          if (!row.materialCode || row.bomEstimate !== undefined) return
          const matched = res.data.find((m: any) => m.materialCode === row.materialCode)
          if (matched) {
            row.bomEstimate = matched.bomEstimate
            row.bomEstimateUnit = matched.bomEstimateUnit
            row.inventory = matched.inventory
            row.inventoryUnit = matched.inventoryUnit
            row.purchasing = matched.purchasing
            row.purchasingUnit = matched.purchasingUnit
            if (row.materialPrice == null || row.materialPrice === '') {
              row.materialPrice = matched.price
            }
            if (matched.productCodes != null && matched.productCodes !== '') {
              const normalized = normalizeProductCodesField(matched.productCodes)
              if (normalized.length > 0) row.productCodes = normalized
            }
          }
        })
      }
    }

    showSuccess('添加成功')
    closeAddPurchaseItemDialog()
  } catch (e: any) {
    console.error('添加采购项失败:', e)
    showError(e?.message || '添加采购项失败')
  } finally {
    addPurchaseItemConfirmLoading.value = false
  }
}

// 计算单项总价
const calculateTotalPrice = (price: number, quantity: number) => {
  if (!price || !quantity) {
    return '0'
  }
  const total = Number(price) * Number(quantity)
  return Number(total.toFixed(2))
}

// 处理数量输入
const handleQuantityInput = (material: any, index: number) => {
  let value = String(material.materialCount || '').trim()
  value = value.replace(/[^\d.]/g, '')

  const dotIndex = value.indexOf('.')
  if (dotIndex !== -1) {
    const beforeDot = value.substring(0, dotIndex)
    const afterDot = value.substring(dotIndex + 1).replace(/\./g, '').substring(0, 4)
    value = beforeDot + '.' + afterDot
  }

  if (value === '' || value === '.') {
    material.materialCount = ''
    return
  }

  // 小数点前自动补0
  if (value.startsWith('.')) {
    value = '0' + value
  }

  value = value.replace(/^0+(\d)/, '$1')
  const num = parseFloat(value)

  if (!isNaN(num) && num >= 0) {
    material.materialCount = value
  } else {
    material.materialCount = ''
  }
}

// 处理单价输入
const handlePriceInput = (material: any, index: number) => {
  let value = String(material.materialPrice || '').trim()
  value = value.replace(/[^\d.]/g, '')

  const dotIndex = value.indexOf('.')
  if (dotIndex !== -1) {
    const beforeDot = value.substring(0, dotIndex)
    const afterDot = value.substring(dotIndex + 1).replace(/\./g, '').substring(0, 2)
    value = beforeDot + '.' + afterDot
  }

  if (value === '' || value === '.') {
    material.materialPrice = ''
    return
  }

  // 小数点前自动补0
  if (value.startsWith('.')) {
    value = '0' + value
  }

  const num = parseFloat(value)
  if (!isNaN(num) && num >= 0) {
    material.materialPrice = value
  } else {
    material.materialPrice = ''
  }
}

// 对外暴露：打开弹窗，并根据请购单数据做赋值
const openForRequisition = async (item: any, index: number, skipTypeSelect = false, vendor: any = null) => {
  currentRequisitionItem.value = item
  currentRequisitionIndex.value = index

  resetPurchaseData()

  const requisitionItems = item.items || []
  selectedMaterialDetails.value = requisitionItems.map((reqItem: any) => ({
    id: reqItem.id,
    requisitionId: reqItem.requisitionId,
    materialCode: reqItem.materialCode,
    contractCode: reqItem.contractCode,
    batch: reqItem.batch,
    syscode: reqItem.syscode,
    materialName: reqItem.materialName,
    specDesc: reqItem.materialSpec,
    materialUnit: reqItem.unit,
    _originalMaterialUnit: reqItem._originalMaterialUnit ?? reqItem.unit ?? null,
    brand: reqItem.brand || '',
    // 请购单场景：优先使用 materialTotalCount（通常来自 productUsageSum），
    // 兼容旧字段 quantity。
    materialTotalCount: reqItem.materialTotalCount ?? null,
    materialCount: reqItem.materialTotalCount != null ? formatNumberUse(reqItem.materialTotalCount, 4) : (reqItem.quantity != null ? formatNumberUse(reqItem.quantity, 4) : null),
    materialPrice: reqItem.materialPrice ?? null,
    remark: reqItem.remark || '',
    plannedDeliveryDate: reqItem.plannedDeliveryDate
      ? new Date(reqItem.plannedDeliveryDate).toISOString().slice(0, 10)
      : '',
    warehouseName: reqItem.warehouseName,
    warehouseNo: reqItem.warehouseNo,
    warehouseStatus: reqItem.warehouseStatus,
    type: reqItem.type || 0,
    materialRemark: reqItem.materialRemark,
    materialType: reqItem.materialType,
    bigClass: reqItem.bigClass,
    smallClass: reqItem.smallClass,
    bomKey: reqItem.bomKey,
    partName: reqItem.partName,
    contractNo: reqItem.contractNo,
    contractId: reqItem.contractId,
    productCodes: normalizeProductCodesField(reqItem.productCodes),
    purchaseItemId: reqItem.purchaseItemId ?? null,
  }))

  const materialCodes: string[] = []
  for (let i = 0; i < selectedMaterialDetails.value.length; i++) {
    materialCodes.push(selectedMaterialDetails.value[i].materialCode)
  }

  if (currentRequisitionItem.value.warehouseNo && currentRequisitionItem.value.warehouseName) {
    purchaseData.value.warehouse = {
      warehouseNo: currentRequisitionItem.value.warehouseNo,
      warehouseName: currentRequisitionItem.value.warehouseName,
    }
  }
  if (requisitionItems.length > 0 && requisitionItems[0].warehouseNo && requisitionItems[0].warehouseName) {
    purchaseData.value.warehouse = {
      warehouseNo: requisitionItems[0].warehouseNo,
      warehouseName: requisitionItems[0].warehouseName,
    }
  }

  purchaseData.value.purchaseNo = currentRequisitionItem.value.requisitionNo

  if (vendor && (vendor.id != null || vendor.companyName)) {
    purchaseData.value.vendor = {
      id: vendor.id != null ? Number(vendor.id) : null,
      companyName: String(vendor.companyName ?? '').trim(),
      rate: vendor.rate != null ? String(vendor.rate) : '0',
      paymentType: vendor.paymentType != null ? String(vendor.paymentType) : '0'
    }
  }

  if (materialCodes.length === selectedMaterialDetails.value.length) {
    const res = await purchaseApi.purchaseProductQuantityInfo({
      materialCodes: materialCodes.join(','),
      warehouseNo: purchaseData.value.warehouse.warehouseNo,
    })
    if (res?.code === 0 && res.data) {
      selectedMaterialDetails.value.forEach((row: any) => {
        const matched = res.data.find((m: any) => m.materialCode === row.materialCode)
        if (matched) {
          row.bomEstimate = matched.bomEstimate
          row.bomEstimateUnit = matched.bomEstimateUnit
          row.inventory = matched.inventory
          row.inventoryUnit = matched.inventoryUnit
          row.purchasing = matched.purchasing
          row.purchasingUnit = matched.purchasingUnit
          if (row.materialPrice == null || row.materialPrice === '') {
            row.materialPrice = matched.price
          }
          if (matched.productCodes != null && matched.productCodes !== '') {
            const normalized = normalizeProductCodesField(matched.productCodes)
            if (normalized.length > 0) row.productCodes = normalized
          }
        }
      })
    }
  }

  calculatePurchaseTotalAmount()
  if (skipTypeSelect) {
    purchaseData.value.purchaseType = 0
    purchaseData.value.purchaseStandard = purchaseData.value.purchaseStandard ?? null
    purchaseData.value.deliveryAddress = ''
    typeSelectVisible.value = false
    visible.value = true
  } else {
    typeSelectVisible.value = true
  }
}

// 对外暴露：从采购详情打开编辑，直接进入主弹窗（区分实物/服务，展示项目名称与合同唯一码由 props 传入）
const openForEdit = (order: any, materialList: any[]) => {
  currentRequisitionItem.value = null
  currentRequisitionIndex.value = -1
  resetPurchaseData()

  const o = order || {}
  const purchaseType = o.purchaseType != null ? Number(o.purchaseType) : (o.purchaseStandard != null ? 0 : (o.deliveryAddress ? 1 : 0))
  purchaseData.value.purchaseType = purchaseType as 0 | 1
  if (purchaseType === 0) {
    purchaseData.value.purchaseStandard = o.purchaseStandard ?? null
    purchaseData.value.deliveryAddress = ''
    purchaseData.value.remark = o.remark ?? physicalPurchaseDefaultRemark
  } else {
    purchaseData.value.purchaseStandard = null
    purchaseData.value.deliveryAddress = o.deliveryAddress ?? ''
    purchaseData.value.remark = o.remark ?? physicalPurchaseDefaultRemark
  }

  purchaseData.value.vendor = (o.vendorId || o.supplierName) ? { id: o.vendorId, companyName: o.supplierName } : null
  const paymentTypeValue = o.paymentType != null ? String(o.paymentType) : '0'
  const matchedPayment = paymentMethods.find(item => item.value === paymentTypeValue)
  purchaseData.value.paymentMethod = matchedPayment || paymentMethods[0]
  const rateValue = o.taxRate != null ? String(o.taxRate) : '0'
  purchaseData.value.taxRate = taxRates.find(item => item.value === rateValue) || taxRates[0]
  const taxValue = o.tax != null ? String(o.tax) : '0'
  purchaseData.value.tax = taxs.find(item => item.value === taxValue) || taxs[0]
  if (o.paymentCompany) {
    const matched = paymentCompanys.find((item: any) => item.value === o.paymentCompany)
    purchaseData.value.paymentCompany = matched || null
  }
  purchaseData.value.warehouse = (o.warehouseNo || o.warehouseName) ? { warehouseNo: o.warehouseNo ?? '', warehouseName: o.warehouseName ?? '' } : { warehouseNo: '', warehouseName: '' }
  purchaseData.value.totalAmount = Number(o.totalPrice ?? o.totalAmount ?? 0)
  purchaseData.value.taxAmount = Number(o.taxAmount ?? 0)
  purchaseData.value.totalAmountWithTax = Number(o.totalAmountWithTax ?? o.totalPrice ?? 0)
  purchaseData.value.purchaseStandard = o.purchaseStandard ?? null
  purchaseData.value.remark = o.remark ?? purchaseData.value.remark
  purchaseData.value.purchaseOrderNo = o.purchaseOrderNo ?? null
  purchaseData.value.id = o.id ?? null
  purchaseData.value.paymentDate = o.schDate ? formatDateForNativeInput(o.schDate) : null

  selectedMaterialDetails.value = (materialList || []).map((item: any) => ({
    id: item.id,
    itemId: item.id,
    materialCode: item.goodsNo ?? item.materialCode,
    contractCode: item.contractCode,
    batch: item.batch,
    syscode: item.syscode,
    materialName: item.goodsName ?? item.materialName,
    specDesc: item.goodsSpec ?? item.specDesc ?? '',
    materialUnit: item.unit ?? item.materialUnit,
    _originalMaterialUnit: item.unit ?? item.materialUnit ?? null,
    materialTotalCount: item.materialTotalCount ?? null,
    materialCount: item.materialTotalCount != null ? formatNumberUse(item.materialTotalCount, 4) : (item.quantity != null ? formatNumberUse(item.quantity, 4) : (item.materialCount != null ? formatNumberUse(item.materialCount, 4) : null)),
    materialPrice: item.price ?? item.materialPrice ?? 0,
    remark: item.remark ?? item.goodsDesc ?? '',
    plannedDeliveryDate: item.plannedDeliveryDate ? formatDateForNativeInput(item.plannedDeliveryDate) : (item.schDate ? formatDateForNativeInput(item.schDate) : ''),
    brand: item.brand ?? '',
    materialRemark: item.materialRemark ?? '',
    materialType: item.materialType ?? '',
    bigClass: item.bigClass ?? '',
    smallClass: item.smallClass ?? '',
    bomEstimate: item.bomEstimate,
    bomEstimateUnit: item.bomEstimateUnit,
    inventory: item.inventory,
    inventoryUnit: item.inventoryUnit,
    purchasing: item.purchasing,
    purchasingUnit: item.purchasingUnit,
    warehouseNo: item.warehouseNo,
    warehouseName: item.warehouseName,
    warehouseStatus: item.warehouseStatus,
    type: item.type ?? 0,
    bomKey: item.bomKey,
    partName: item.partName,
    productCodes: normalizeProductCodesField(item.productCodes),
    purchaseItemId: item.purchaseItemId ?? null,
  }))

  calculatePurchaseTotalAmount()
  typeSelectVisible.value = false
  visible.value = true
}

// 关闭弹窗
const handleClose = () => {
  visible.value = false
  currentRequisitionItem.value = null
  currentRequisitionIndex.value = -1
  selectedMaterialDetails.value = []
  resetPurchaseData()
}

// 提交采购
const materialFieldDialogVisible = ref(false)
const materialFieldDialogTitle = ref('')
const materialFieldForm = reactive<any>({
  partName: '',
  materialName: '',
  specDesc: '',
  materialCode: '',
  batch: '',
  syscode: '',
})
let editingMaterialRef: any = null

const openMaterialFieldDialog = (material: any) => {
  editingMaterialRef = material
  materialFieldDialogTitle.value = material.materialName || '编辑物料信息'
  materialFieldForm.partName = material.partName ?? ''
  materialFieldForm.materialName = material.materialName ?? ''
  materialFieldForm.specDesc = material.specDesc ?? ''
  materialFieldForm.materialCode = material.materialCode ?? ''
  materialFieldForm.batch = material.batch ?? ''
  materialFieldForm.syscode = material.syscode ?? ''
  materialFieldDialogVisible.value = true
}

const confirmMaterialFieldDialog = () => {
  if (!editingMaterialRef) return
  if (editingMaterialRef.partName != null) {
    editingMaterialRef.partName = materialFieldForm.partName
  }
  if (editingMaterialRef.materialName != null) {
    editingMaterialRef.materialName = materialFieldForm.materialName
  }
  if (editingMaterialRef.specDesc != null) {
    editingMaterialRef.specDesc = materialFieldForm.specDesc
  }
  if (editingMaterialRef.materialCode != null) {
    editingMaterialRef.materialCode = materialFieldForm.materialCode
  }
  if (editingMaterialRef.batch != null) {
    editingMaterialRef.batch = materialFieldForm.batch
  }
  if (editingMaterialRef.syscode != null) {
    editingMaterialRef.syscode = materialFieldForm.syscode
  }
  materialFieldDialogVisible.value = false
  editingMaterialRef = null
}

const submitPurchase = async () => {
  console.log('purchaseData', selectedMaterialDetails.value)
  if (!purchaseData.value.vendor) {
    showError('请选择供应商')
    return
  }
  if (!purchaseData.value.warehouse?.warehouseNo) {
    showError('请选择收货仓库')
    return
  }
  if (purchaseData.value.purchaseType === 1 && !String(purchaseData.value.deliveryAddress || '').trim()) {
    showError('请填写送货地址')
    return
  }
  console.log('selectedMaterialDetails', selectedMaterialDetails.value)
  if(selectedMaterialDetails.value.some((item: any) => item._isExtraExpense && item.materialName ==='')) {
    showError('费用类型不能为空')
    return
  }
  if (
    !purchaseData.value.paymentCompany ||
    purchaseData.value.paymentCompany.value === '' ||
    purchaseData.value.paymentCompany === null ||
    purchaseData.value.paymentCompany === ''
  ) {
    showError('请选择付款公司')
    return
  }
  for (let i = 0; i < selectedMaterialDetails.value.length; i++) {
    const row = selectedMaterialDetails.value[i]
    // 常规材料/五金（当前明细中为 type === 0）需要校验名称与编码
    if (row?.type === 0) {
      const materialName = String(row.materialName || '').trim()
      const partName = String(row.partName || '').trim()
      const materialCode = String(row.materialCode || '').trim()
      const hasName = !!(materialName || partName)
      // if (!hasName || !materialCode) {
      //   showError(`第${i + 1}行需填写物料名称或构件名称，且编码不得为空`)
      //   return
      // }
      if (!materialName || !materialCode) {
        showError(`第${i + 1}行名称和编码不得为空`)
        return
      }
    }
  }
  for (let i = 0; i < selectedMaterialDetails.value.length; i++) {
    if (
      selectedMaterialDetails.value[i].materialCount == null ||
      selectedMaterialDetails.value[i].materialCount === '' ||
      selectedMaterialDetails.value[i].materialCount <= 0
    ) {
      showError('请输入物料数量')
      return
    }
    if (
      selectedMaterialDetails.value[i].materialPrice == null ||
      selectedMaterialDetails.value[i].materialPrice === '' ||
      selectedMaterialDetails.value[i].materialPrice < 0
      // selectedMaterialDetails.value[i].materialPrice <= 0
    ) {
      showError('请输入物料单价')
      return
    }
  }

  const tempMaterialList = selectedMaterialDetails.value
  const materialList: any[] = []
  for (let i = 0; i < tempMaterialList.length; i++) {
    const base: any = {
      materialCode: tempMaterialList[i].materialCode,
      quantity: tempMaterialList[i].materialCount,
      // 传给后端用于区分汇总用量/明细用量
      materialTotalCount: tempMaterialList[i].materialTotalCount ?? tempMaterialList[i].materialCount,
      price: tempMaterialList[i].materialPrice,
      remark: tempMaterialList[i].remark,
      brand: tempMaterialList[i].brand,
      materialName: tempMaterialList[i].materialName,
      specDesc: tempMaterialList[i].specDesc,
      materialUnit: tempMaterialList[i].materialUnit,
      plannedDeliveryDate: tempMaterialList[i].plannedDeliveryDate,
      bomEstimate: tempMaterialList[i].bomEstimate,
      bomEstimateUnit: tempMaterialList[i].bomEstimateUnit,
      inventory: tempMaterialList[i].inventory,
      inventoryUnit: tempMaterialList[i].inventoryUnit,
      purchasing: tempMaterialList[i].purchasing,
      purchasingUnit: tempMaterialList[i].purchasingUnit,
      materialRemark: tempMaterialList[i].materialRemark,
      materialType: tempMaterialList[i].materialType,
      bigClass: tempMaterialList[i].bigClass,
      smallClass: tempMaterialList[i].smallClass,
      contractCode: tempMaterialList[i].contractCode,
      batch: tempMaterialList[i].batch,
      syscode: tempMaterialList[i].syscode,
      type: tempMaterialList[i].type,
      bomKey: tempMaterialList[i].bomKey,
      partName: tempMaterialList[i].partName,
      contractNo: tempMaterialList[i].contractNo,
      productCodes: (Array.isArray(tempMaterialList[i].productCodes)
        ? tempMaterialList[i].productCodes
        : []
      ).join(',') || '',
      purchaseItemId: tempMaterialList[i].purchaseItemId ?? null,
    }

    // 仅在从“请购单”发起采购时传 requisitionItemId，避免合同直采误传
    // 从请购单打开时 currentRequisitionItem 一定有值（包括多选合并的临时请购单，可能没有 id）
    if (currentRequisitionItem.value && tempMaterialList[i].id) {
      base.requisitionItemId = tempMaterialList[i].id
    }
    // 编辑时传 itemId 供后端更新明细
    if (tempMaterialList[i].itemId != null) {
      base.itemId = tempMaterialList[i].itemId
    }

    materialList.push(base)
  }

  try {
    purchaseLoading.value = true
    // 汇总本次采购关联的请购单 id（可能为多个，用英文逗号拼接）
    const requisitionIdSet = new Set<any>()
    selectedMaterialDetails.value.forEach((row: any) => {
      if (row && row.requisitionId != null && row.requisitionId !== '') {
        requisitionIdSet.add(row.requisitionId)
      }
    })
    const requisitionIdStr =
      Array.from(requisitionIdSet)
        .map(id => String(id))
        .filter(id => id !== '')
        .join(',') || null
    const submitData: any = {
      // 后端期望为请购单 id 字段，兼容多请购单合并（英文逗号拼接）
      requisitionId: requisitionIdStr ?? (currentRequisitionItem.value?.id ?? null),
      ...(purchaseData.value.id != null ? { id: purchaseData.value.id } : {}),
      purchaseType: purchaseData.value.purchaseType,
      vendorId: purchaseData.value.vendor?.id,
      warehouseNo: purchaseData.value.warehouse?.warehouseNo,
      warehouseName: purchaseData.value.warehouse?.warehouseName,
      deliveryAddress: purchaseData.value.deliveryAddress,
      paymentCompany: purchaseData.value.paymentCompany.value,
      totalAmount: purchaseData.value.totalAmount,
      taxAmount: purchaseData.value.taxAmount,
      totalAmountWithTax: purchaseData.value.totalAmountWithTax,
      tax: purchaseData.value.tax.value,
      taxRate: purchaseData.value.taxRate.value,
      purchaseStandard: purchaseData.value.purchaseStandard,
      materialList,
      schDate: dateTimestamp(purchaseData.value.paymentDate),
      paymentType:
        typeof purchaseData.value.paymentMethod === 'string'
          ? purchaseData.value.paymentMethod
          : purchaseData.value.paymentMethod.value,
      remark: purchaseData.value.remark,
      contractCode: props.contractCode || undefined,
      projectName: props.projectName || undefined,
    }

    // 合同直采（无请购单）时带上 contractId（与 MaterialListSummary 旧流程保持一致）
    if (!submitData.requisitionId && props.contractId !== undefined && props.contractId !== null && props.contractId !== '') {
      submitData.contractId = Number(props.contractId)
    }

    if (props.contractIds && Array.isArray(props.contractIds) && props.contractIds.length > 0) {
      submitData.contractIds = props.contractIds.join(',')
    }
    
    const res = await purchaseApi.purchaseInitiate(submitData)
    if (res?.code === 0) {
      showSuccess(purchaseData.value.id ? '采购单修改成功' : '采购单创建成功')
      emit('success', {
        requisitionId: currentRequisitionItem.value?.id ?? null,
        requisitionIndex: currentRequisitionIndex.value,
      })
      handleClose()
    } else {
      showError(res?.message || res?.msg || '提交采购失败')
    }
  } catch (error: any) {
    console.error('提交采购失败:', error)
    showError(error.message || '提交采购失败')
  } finally {
    purchaseLoading.value = false
  }
}

defineExpose({
  openForRequisition,
  openForEdit,
})
</script>

<style scoped lang="scss">
.purchase-dialog {
  background-color: #2B2D33 !important;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
}

.purchase-dialog :deep(.v-card-title) {
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 16px 24px;
  font-size: 18px;
  font-weight: 500;
}

.purchase-dialog :deep(.v-card-text) {
  padding: 24px;
  flex: 1 1 auto;
  overflow-y: auto;
}

.purchase-dialog :deep(.v-card-actions) {
  padding: 16px 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.purchase-dialog :deep(.v-autocomplete .v-field__input),
.purchase-dialog :deep(.v-text-field .v-field__input),
.purchase-dialog :deep(.v-autocomplete input),
.purchase-dialog :deep(.v-text-field input),
.purchase-dialog :deep(.v-select .v-field__input),
.purchase-dialog :deep(.v-select input),
.purchase-dialog :deep(.v-select .v-select__selection-text) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__outline),
.purchase-dialog :deep(.v-text-field .v-field__outline),
.purchase-dialog :deep(.v-select .v-field__outline) {
  color: rgba(255, 255, 255, 0.12) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__input::placeholder),
.purchase-dialog :deep(.v-text-field .v-field__input::placeholder) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.purchase-dialog :deep(.v-label) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-autocomplete .v-field__append-inner i),
.purchase-dialog :deep(.v-text-field .v-field__append-inner i),
.purchase-dialog :deep(.v-select .v-field__append-inner i) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.purchase-dialog :deep(.v-list) {
  background-color: #2B2D33 !important;
}

.purchase-dialog :deep(.v-list-item) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item:hover) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.purchase-dialog :deep(.v-list-item-title) {
  color: #fff !important;
}

.purchase-dialog :deep(.v-list-item-subtitle) {
  color: rgba(255, 255, 255, 0.6) !important;
}

.purchase-dialog :deep(.v-messages__message) {
  color: #ff5252 !important;
}

/* 隐藏数字输入框的箭头 */
.purchase-dialog :deep(input[type="number"])::-webkit-inner-spin-button,
.purchase-dialog :deep(input[type="number"])::-webkit-outer-spin-button {
  appearance: none;
  -webkit-appearance: none;
  margin: 0;
}

.purchase-dialog :deep(input[type="number"]) {
  appearance: textfield;
  -moz-appearance: textfield;
}

.purchase-dialog :deep(.mdi) {
  color: #fff !important;
}

/* 只读字段样式 */
:deep(.v-field--readonly) {
  background-color: rgba(255, 255, 255, 0.05) !important;
}

:deep(.v-field--readonly .v-field__input) {
  color: rgba(255, 255, 255, 0.5) !important;
}

:deep(.v-field--readonly .mdi-menu-down) {
  display: none !important;
}

/* 物料采购列表样式 */
.material-purchase-list {
  margin: 10px 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

.material-purchase-header {
  display: flex;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  background-color: rgba(255, 255, 255, 0.04);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.material-purchase-body {
  // max-height: 400px;
  // overflow-y: auto;
}

.material-purchase-item {
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  transition: background-color 0.2s;
}

.material-purchase-item:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.material-purchase-item:last-child {
  border-bottom: none;
}

.material-purchase-item .item-content {
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 0 4px;
  word-break: break-all;
}

.material-purchase-item .material-name {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
}

.material-purchase-item .material-code {
  color: #898989;
  font-size: 12px;
}

/* 自动增长文本框样式 */
.auto-grow-textarea :deep(.v-field__input) {
  // min-height: 36px !important;
  padding: 6px 8px !important;
  line-height: 1.5;
  overflow-y: hidden !important;
  resize: none !important;
}

.auto-grow-textarea :deep(.v-field) {
  // min-height: 36px !important;
}

.auto-grow-textarea :deep(.v-field__outline) {
  // min-height: 36px !important;
}

.auto-grow-textarea :deep(textarea) {
  overflow: hidden !important;
  resize: none !important;
}

/* 日期选择器样式 */
.native-date-field :deep(.v-field__input) {
  cursor: pointer;
}

/* 滚动条样式 */
.purchase-dialog::-webkit-scrollbar,
.material-purchase-body::-webkit-scrollbar,
.purchase-dialog :deep(.v-card-text)::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.purchase-dialog::-webkit-scrollbar-track,
.material-purchase-body::-webkit-scrollbar-track,
.purchase-dialog :deep(.v-card-text)::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

.purchase-dialog::-webkit-scrollbar-thumb,
.material-purchase-body::-webkit-scrollbar-thumb,
.purchase-dialog :deep(.v-card-text)::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 100%);
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.purchase-dialog::-webkit-scrollbar-thumb:hover,
.material-purchase-body::-webkit-scrollbar-thumb:hover,
.purchase-dialog :deep(.v-card-text)::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0.2) 100%);
  border-color: rgba(255, 255, 255, 0.2);
}

.purchase-associated-products-tip-img {
  width: 14px;
  height: 14px;
  vertical-align: middle;
  cursor: pointer;
  display: inline-block;
}

.purchase-associated-products-tip-wrap {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

.purchase-associated-products-count {
  font-size: 12px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.85);
}

.purchase-associated-products-tooltip {
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-all;
}

.purchase-associated-products-editable {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  cursor: pointer;
  text-align: left;
  padding: 4px 6px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  min-height: 36px;
}

.purchase-associated-products-editable:hover {
  background: rgba(255, 255, 255, 0.06);
}

.purchase-associated-products-editable-text {
  flex: 1;
  min-width: 0;
}

.purchase-associated-product-line {
  margin-bottom: 4px;
  font-size: 13px;
  line-height: 1.35;
  word-break: break-all;
}

.purchase-associated-placeholder {
  color: rgba(255, 255, 255, 0.45);
}

.purchase-associated-products-edit-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  margin-top: 2px;
  opacity: 0.85;
}

.purchase-associated-product-table {
  background: transparent !important;
}

.purchase-associated-product-table :deep(th),
.purchase-associated-product-table :deep(td) {
  color: rgba(255, 255, 255, 0.88) !important;
  font-size: 13px !important;
}

.edit-parent{
  position: relative;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

/* 原生日期输入框包装器样式 */
.native-date-wrapper {
  position: relative;
}

.native-date-wrapper :deep(.v-field__input){
  cursor: pointer;
}

.native-date-field {
  cursor: pointer;
}

.native-date-field:hover {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.native-date-field:focus-within {
  border-color: #D2475D !important;
}

/* 增加采购项弹窗表格样式 */
.add-purchase-item-list {
  margin: 10px 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

.add-purchase-item-header {
  display: flex;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  background-color: rgba(255, 255, 255, 0.04);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.add-purchase-item-body {
  max-height: 400px;
  overflow-y: auto;
}

.add-purchase-item-row {
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  transition: background-color 0.2s;
}

.add-purchase-item-row:hover {
  background-color: rgba(255, 255, 255, 0.03);
}

.add-purchase-item-row:last-child {
  border-bottom: none;
}

.add-purchase-item-row .item-content {
  color: #fff;
  font-size: 13px;
  text-align: center;
  padding: 0 4px;
  word-break: break-all;
}

.add-purchase-item-row .material-name {
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
}

.add-purchase-item-row .material-code {
  color: #898989;
  font-size: 12px;
}

.add-purchase-item-row .product-code-line {
  margin-bottom: 2px;
  font-size: 12px;
  line-height: 1.35;
  word-break: break-all;
}

.add-purchase-item-row .remark-text {
  display: inline-block;
  max-width: 120px;
  word-break: break-all;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
}

.custom-pagination {
  padding: 8px 0;
  color: rgba(255, 255, 255, 0.7);
}

.pagination-btn {
  color: rgba(255, 255, 255, 0.7) !important;
}

.pagination-text {
  font-size: 14px;
}

.search-type-toggle {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 32px;
  .button-group {
    border-radius: 24px;
    background-color: #333;
    overflow: hidden;
    height: 32px;
  }

  .toggle-button {
    min-width: 42px;
    border-radius: 24px;
    font-weight: 500;
    color: #999 !important;
    height: 100%!important;

    &.v-btn--active {
      background: var(--primary-gradient) !important;
      color: white !important;
    }
  }
}

  :deep(.mdi-checkbox-marked){
    color: #D2475D !important;
  }

  :deep(.v-selection-control__input::before),
  :deep(.mdi-checkbox-marked::before){
    color: #D2475D !important;
  }

  :deep(.add-purchase-item-list) ::-webkit-scrollbar{
    width: 8px;
    height: 8px;
  }
  :deep(.add-purchase-item-list) ::-webkit-scrollbar-track{
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }
  :deep(.add-purchase-item-list) ::-webkit-scrollbar-thumb{
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 4px;
    transition: all 0.3s ease;
  }
  :deep(.add-purchase-item-list) ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.3);
  }
</style>

